//TODO: At some point, use this more modular approach to merge the seasonal rental map functionality as well


const homepageMapState = {
    map: null,
    markerArray: [],
    markerInfoWindow: null,
    mapStyle: [
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{"color": "#e9e9e9"}, {"lightness": 17}]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [{"color": "#f5f5f5"}, {"lightness": 20}]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [{"color": "#ffffff"}, {"lightness": 17}]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [{"color": "#ffffff"}, {"lightness": 29}, {"weight": 0.2}]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [{"color": "#ffffff"}, {"lightness": 18}]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [{"color": "#ffffff"}, {"lightness": 16}]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [{"color": "#dedede"}, {"lightness": 21}]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [{"visibility": "on"}, {"color": "#ffffff"}, {"lightness": 16}]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [{"saturation": 36}, {"color": "#333333"}, {"lightness": 40}]
        },
    ]
}


const initHomepageMap = () => {
    const element = document.querySelector('#sr-google-map.homepage-google-map')
    if (!element) return
    homepageMapState.markerInfoWindow = new google.maps.InfoWindow();
    homepageMapState.map = new google.maps.Map(element, {
        streetViewControl: false,
        scrollwheel: true,
        disableDefaultUI: true,
        zoomControl: true,
        styles: homepageMapState.mapStyle,
        mapTypeId: google.maps.MapTypeId.ROADMAP
    });

    window.refreshHomePageMapMarkers = () => initMapMarkers(homepageLocationsCollector);
    window.refreshHomePageMapMarkers()
}

const homepageLocationsCollector = () => {
    const locationList = jQuery(".available-ski-areas-ul .location-link");
    if (!locationList || !locationList.length) return [];
    return locationList.map(function (_idx, element) {
        const jqEl = $(element);
        const addressLon = Number(String(jqEl.data('address-lon')).replace(',', '.'));
        const addressLat = Number(String(jqEl.data('address-lat')).replace(',', '.'));


        return {
            geometry: {
                type: "Point",
                coordinates: [addressLat, addressLon]
            },
            type: "Feature",
            properties: {
                name: jqEl.data("destination-name"),
                street: jqEl.data("address-street"),
                city: jqEl.data("address-city"),
                zipCode: jqEl.data("address-zip-code"),
                phone: jqEl.data("phone"),
                email: jqEl.data("email"),
                location_slug: jqEl.data("location-slug"),
            },
        }
    }).toArray();
}


const initMapMarkers = collectorFunction => {
    homepageMapState.markerInfoWindow.close()
    homepageMapState.markerInfoWindow.setOptions({pixelOffset: new google.maps.Size(0, -30)});
    google.maps.event.addListener(homepageMapState.map, 'click', () => {
        homepageMapState.markerArray.close();
    });

    const rawMarkerData = collectorFunction && collectorFunction();
    purgeMarkers()
    if (!rawMarkerData || !rawMarkerData.length) {
        return;
    }

    rawMarkerData.forEach((rawMarker) => {
        const lat = rawMarker.geometry.coordinates[0];
        const lng = rawMarker.geometry.coordinates[1];

        const iconUrlBase = `${window.location.protocol}//${window.location.host}`;
        const iconUrlPath = `/static/img/season_rental/markers/marker-2.png`;
        const iconUrlFull = iconUrlBase + iconUrlPath;
        const icon = {
            url: iconUrlFull,
            scaledSize: new google.maps.Size(32, 49),
        };
        const marker = new google.maps.Marker({
            position: {lat: lat, lng: lng},
            map: homepageMapState.map,
            icon: icon,
        });
        marker.extraData = rawMarker.properties;

        marker.addListener('click', () => {
            renderHomepageMarker(marker);
        });

        homepageMapState.markerArray.push(marker);
    });
    scaleMapToFitMakers(homepageMapState)
}


const renderHomepageMarker = (marker) => {
    const destinationName = marker.extraData.name;
    const street = marker.extraData.street;
    const city = marker.extraData.city;
    const zipCode = marker.extraData.zipCode;
    const phone = marker.extraData.phone;
    const email = marker.extraData.email;
    const location_slug = marker.extraData.location_slug;

    const content = `
        <div class="store-info-box">

            <div class="name">
                ${destinationName}
            </div>

            <div class="address">
                <div class="street">${street}</div>
                <div class="zipcode">${zipCode} ${city}</div>
                <div class="tel">${phone}</div>
                <div class="email-website"><a href="mailto:${email}">${email}</a></div>
            </div>
            <div>
                <a href="${DJANGO.locationsUrl.replace('placeholder', location_slug)}">
                    <button type="submit" class="c-button c-button--full-width-xs">
                        ${DJANGO.i18n.Select}
                    </button>
                </a>
            </div>
        </div>
    `;

    homepageMapState.markerInfoWindow.setContent(content);
    homepageMapState.markerInfoWindow.setPosition(marker.getPosition());
    homepageMapState.markerInfoWindow.open(homepageMapState.map);
}


const scaleMapToFitMakers = () => {
    const mapBounds = new google.maps.LatLngBounds();
    homepageMapState.markerArray.forEach((marker) => {
        mapBounds.extend(marker.getPosition());
    });
    homepageMapState.map.fitBounds(mapBounds);
}

const purgeMarkers = () => {
    homepageMapState.markerArray.forEach(marker => marker.setMap(null));
    homepageMapState.markerArray = [];
}

module.exports = {initHomepageMap};



// WEBPACK FOOTER //
// ./private/js/homepage_google_map.js